import { defineComponent as _defineComponent } from 'vue'
import { BasketType } from "@/enums";
import { store } from "@/store";
import { computed, ref } from "vue";
import UpdateLineItemWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateLineItemWebRequest;
import RemoveFromBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.RemoveFromBasketWebRequest;
import ServerContextService from "@/core/server-context.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniBasketItemB2C',
  props: {
    item: null,
    vatText: null,
    showVatText: { type: Boolean },
    basketType: null
  },
  setup(__props: any) {

const props = __props as {item: LineItemViewObject, vatText?: string, showVatText: boolean, basketType: BasketType}



const isPointOfSaleMode = computed<boolean>(() => store.getters['app/isPointOfSaleMode']);

function removeFromBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch("basket/removeFromBasket", request);
}

function updateLineItem(request: UpdateLineItemWebRequest) {
    store.dispatch("basket/updateLineItem", request);
}

function remove(lineItemId: number) {
    removeFromBasket({ id: lineItemId, basketType: props.basketType as any});
}

function onQuantityChange(quantity: number) {
    if (quantity === props.item.quantity) {
        return;
    }
    updateLineItem({ id: props.item.lineItemId, quantity, discountPercent: null, basketType: props.basketType as any, customConfiguration: null });
}

const isBasketLocked = computed<boolean>(() => store.getters["basket/isBasketLocked"]);
const quantities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

const showErrorImage = ref<boolean>(false);
const showSpinner = ref<boolean>(true);

const locale = ServerContextService.languages.find(l => l.isSelected).code;
const isJapanMarket = locale.toLowerCase() === "ja-JP".toLowerCase();

function showDeliveryTime(deliveryTime) {
    if (isJapanMarket) {
        return deliveryTime !== "Labels.LP.Shared.DeliveryTimes.Code";
    }

    return true;
}

function imageSuccess() {
    showErrorImage.value = false;
    showSpinner.value = false;
}

function imageError() {
    showErrorImage.value = true;
    showSpinner.value = false;
}

return { __sfc: true,props, isPointOfSaleMode, removeFromBasket, updateLineItem, remove, onQuantityChange, isBasketLocked, quantities, showErrorImage, showSpinner, locale, isJapanMarket, showDeliveryTime, imageSuccess, imageError }
}

})